import {Franchise} from "@/components/PostcodeManagement/ValueObject/Franchise";

export default class DefaultState{
  loading = false;
  franchises: Franchise[] = [];
  allFranchises: Franchise[] = [];
  suggestionTimeout: Record<string, unknown>[]|null = null;
  dialog = false;
}
